import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {BrandMapPinIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";
import {navigationHeight} from "@pg-rp/navigation";

import {useCookieBotObserver} from "../../../navigation/hooks/use_cookie_bot_observer";
import {SlotOrderType} from "../../../search/components/search_autocomplete/SearchAutocompleteInputWithSlot";
import {SearchFormWithDrawer} from "../../../search/components/SearchFormWithDrawer";
import {searchFormWithDrawerHeight} from "../../../search/constants/search_form_with_drawer_height";
import {useSearchForm} from "../../../search/hooks/use_search_form";
import {tdaDesktopHeight} from "../../../smart_ad_server/constants/tda_desktop_height";
import {useAppSelector} from "../../../store/hooks";
import {trackAmplitudeButtonClick} from "../../../tracking/amplitude/track_amplitude_button_click";
import {ILatestQuery} from "../../../utils/latest_query";
import {useOffersViewsUrl} from "../../hooks/use_offers_views_url";
import {getOrCreateOfferListingAmplitudeItemListId} from "../helpers/offer_listing_amplitude_item_list_id";
import {useListingStickyHeaderBehavior} from "../hooks/use_listing_sticky_header_behavior";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";

interface IProps {
    latestQuery?: ILatestQuery;
    hideBottomPadding?: boolean;
}

export const ListingStickyHeader = (props: IProps) => {
    const {hideBottomPadding, latestQuery} = props;

    const {isMobile} = useUserDevice();
    const {isCookieBotOpen} = useCookieBotObserver();
    const {mapUrl} = useOffersViewsUrl();
    const stickyHeaderVisibility = useAppSelector((state) => state.offerListing.stickyHeaderVisibility);
    const isHeaderVisible = stickyHeaderVisibility === 1;

    const {wrapperRef, currentHeaderHeight} = useListingStickyHeaderBehavior({isMobile: Boolean(isMobile)});

    const {isLocationSearchOpen} = useSearchForm();

    const handleMapButtonClick = () => {
        trackAmplitudeButtonClick({
            buttonName: "view_map",
            buttonCategory: "listing_page",
            value: "see_on_map",
            itemId: null,
            buttonLink: null,
            itemListId: latestQuery ? getOrCreateOfferListingAmplitudeItemListId(latestQuery as IOfferListLatestQuery) : null
        });
    };

    return (
        <div ref={wrapperRef} className={cx(headerWrapperStyle, getHeaderWrapperStickyStyle(isHeaderVisible, isLocationSearchOpen))}>
            {!isMobile && !!latestQuery && (
                <div className={isHeaderVisible ? stickyBarShellVisible : stickyBarShell}>
                    <Container className={containerStyle}>
                        {isHeaderVisible && (
                            <SearchFormWithDrawer
                                listFriendlyLink={({friendlySlug, offerListSubFilterSlug}) => {
                                    return offerListSubFilterSlug
                                        ? rpAppLink.offer.listFriendlySubFilterGeneral({friendlySlug, offerListSubFilter: offerListSubFilterSlug})
                                        : rpAppLink.offer.listFriendly({friendlySlug});
                                }}
                                abroadListFriendlyLink={(params) => rpAppLink.offer.listFriendlyAbroad(params)}
                                multiRegionLink={rpAppLink.offer.multiList}
                                latestQuery={latestQuery}
                                sortActive
                                shouldRenderListBackBtn
                                // TODO: Sometimes blend is relative to their elements, navigationHeight should be removed from atoms/DesktopBlend implementation
                                blendTop={`${currentHeaderHeight - navigationHeight}px`}
                                blendHeightDecrease={`${currentHeaderHeight + navigationHeight + tdaDesktopHeight * 2 + searchFormWithDrawerHeight}px`}
                                className="isInNavigationBar"
                                slotOrder={SlotOrderType.ROW_REVERSE}
                                hideBottomPadding={hideBottomPadding}
                                disableFilterAutoShowcase
                                disableLocationSearch={isCookieBotOpen}
                            />
                        )}

                        <Button
                            href={mapUrl}
                            onClick={handleMapButtonClick}
                            iconLeft={BrandMapPinIcon}
                            variant="brand_icon"
                            size="medium"
                            className={buttonStyle}
                        >
                            Zobacz na mapie
                        </Button>
                    </Container>
                </div>
            )}
        </div>
    );
};

const getHeaderWrapperStickyStyle = (isHeaderVisible: boolean, isLocationSearchOpen: boolean) => {
    if (!isHeaderVisible) {
        return headerWrapperHiddenZIndexStyle;
    }

    return isLocationSearchOpen ? headerWrapperLocationSearchZIndexStyle : headerWrapperVisibleZIndexStyle;
};

const headerWrapperStyle = css({
    display: "none",

    md: {
        display: "block",
        position: "sticky",
        top: 0,
        height: 0,
        pointerEvents: "none"
    }
});

const headerWrapperHiddenZIndexStyle = css({
    zIndex: -1
});

const headerWrapperVisibleZIndexStyle = css({
    zIndex: 22
});

const headerWrapperLocationSearchZIndexStyle = css({
    zIndex: 51
});

const stickyBarShellBase = css.raw({
    position: "fixed",
    left: 0,
    right: 0,
    top: 0,
    py: 1,
    background: "var(--colors-white)",
    width: "100%",
    willChange: "transform"
});

const stickyBarShell = css({
    ...stickyBarShellBase,
    pointerEvents: "none",
    transition: "transform 0.15s ease-out, box-shadow 0s linear",
    transform: "translateY(-100%)",
    boxShadow: "none"
});

const stickyBarShellVisible = css({
    ...stickyBarShellBase,
    zIndex: 22,
    pointerEvents: "auto",
    transition: "transform 0.15s ease-out, box-shadow 0.15s ease-out",
    transform: "translateY(0)",
    boxShadow: "var(--shadows-4)"
});

const buttonStyle = css({
    transitionDuration: "unset",
    transitionTimingFunction: "unset",
    overflow: "initial"
});

const containerStyle = css({
    textAlign: "right",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "100%",
    flexBasis: "100%",

    "& > div:first-of-type": {
        width: "100%",
        flexBasis: "100%"
    }
});
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {BrandMapPinIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";
import {navigationHeight} from "@pg-rp/navigation";

import {useCookieBotObserver} from "../../../navigation/hooks/use_cookie_bot_observer";
import {SlotOrderType} from "../../../search/components/search_autocomplete/SearchAutocompleteInputWithSlot";
import {SearchFormWithDrawer} from "../../../search/components/SearchFormWithDrawer";
import {searchFormWithDrawerHeight} from "../../../search/constants/search_form_with_drawer_height";
import {useSearchForm} from "../../../search/hooks/use_search_form";
import {tdaDesktopHeight} from "../../../smart_ad_server/constants/tda_desktop_height";
import {useAppSelector} from "../../../store/hooks";
import {trackAmplitudeButtonClick} from "../../../tracking/amplitude/track_amplitude_button_click";
import {ILatestQuery} from "../../../utils/latest_query";
import {useOffersViewsUrl} from "../../hooks/use_offers_views_url";
import {getOrCreateOfferListingAmplitudeItemListId} from "../helpers/offer_listing_amplitude_item_list_id";
import {useListingStickyHeaderBehavior} from "../hooks/use_listing_sticky_header_behavior";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";

interface IProps {
    latestQuery?: ILatestQuery;
    hideBottomPadding?: boolean;
}

export const ListingStickyHeader = (props: IProps) => {
    const {hideBottomPadding, latestQuery} = props;

    const {isMobile} = useUserDevice();
    const {isCookieBotOpen} = useCookieBotObserver();
    const {mapUrl} = useOffersViewsUrl();
    const stickyHeaderVisibility = useAppSelector((state) => state.offerListing.stickyHeaderVisibility);
    const isHeaderVisible = stickyHeaderVisibility === 1;

    const {wrapperRef, currentHeaderHeight} = useListingStickyHeaderBehavior({isMobile: Boolean(isMobile)});

    const {isLocationSearchOpen} = useSearchForm();

    const handleMapButtonClick = () => {
        trackAmplitudeButtonClick({
            buttonName: "view_map",
            buttonCategory: "listing_page",
            value: "see_on_map",
            itemId: null,
            buttonLink: null,
            itemListId: latestQuery ? getOrCreateOfferListingAmplitudeItemListId(latestQuery as IOfferListLatestQuery) : null
        });
    };

    return (
        <div ref={wrapperRef} className={cx(headerWrapperStyle, getHeaderWrapperStickyStyle(isHeaderVisible, isLocationSearchOpen))}>
            {!isMobile && !!latestQuery && (
                <div className={isHeaderVisible ? stickyBarShellVisible : stickyBarShell}>
                    <Container className={containerStyle}>
                        {isHeaderVisible && (
                            <SearchFormWithDrawer
                                listFriendlyLink={({friendlySlug, offerListSubFilterSlug}) => {
                                    return offerListSubFilterSlug
                                        ? rpAppLink.offer.listFriendlySubFilterGeneral({friendlySlug, offerListSubFilter: offerListSubFilterSlug})
                                        : rpAppLink.offer.listFriendly({friendlySlug});
                                }}
                                abroadListFriendlyLink={(params) => rpAppLink.offer.listFriendlyAbroad(params)}
                                multiRegionLink={rpAppLink.offer.multiList}
                                latestQuery={latestQuery}
                                sortActive
                                shouldRenderListBackBtn
                                // TODO: Sometimes blend is relative to their elements, navigationHeight should be removed from atoms/DesktopBlend implementation
                                blendTop={`${currentHeaderHeight - navigationHeight}px`}
                                blendHeightDecrease={`${currentHeaderHeight + navigationHeight + tdaDesktopHeight * 2 + searchFormWithDrawerHeight}px`}
                                className="isInNavigationBar"
                                slotOrder={SlotOrderType.ROW_REVERSE}
                                hideBottomPadding={hideBottomPadding}
                                disableFilterAutoShowcase
                                disableLocationSearch={isCookieBotOpen}
                            />
                        )}

                        <Button
                            href={mapUrl}
                            onClick={handleMapButtonClick}
                            iconLeft={BrandMapPinIcon}
                            variant="brand_icon"
                            size="medium"
                            className={buttonStyle}
                        >
                            Zobacz na mapie
                        </Button>
                    </Container>
                </div>
            )}
        </div>
    );
};

const getHeaderWrapperStickyStyle = (isHeaderVisible: boolean, isLocationSearchOpen: boolean) => {
    if (!isHeaderVisible) {
        return headerWrapperHiddenZIndexStyle;
    }

    return isLocationSearchOpen ? headerWrapperLocationSearchZIndexStyle : headerWrapperVisibleZIndexStyle;
};

const headerWrapperStyle = css({
    display: "none",

    md: {
        display: "block",
        position: "sticky",
        top: 0,
        height: 0,
        pointerEvents: "none"
    }
});

const headerWrapperHiddenZIndexStyle = css({
    zIndex: -1
});

const headerWrapperVisibleZIndexStyle = css({
    zIndex: 22
});

const headerWrapperLocationSearchZIndexStyle = css({
    zIndex: 51
});

const stickyBarShellBase = css.raw({
    position: "fixed",
    left: 0,
    right: 0,
    top: 0,
    py: 1,
    background: "var(--colors-white)",
    width: "100%",
    willChange: "transform"
});

const stickyBarShell = css({
    ...stickyBarShellBase,
    pointerEvents: "none",
    transition: "transform 0.15s ease-out, box-shadow 0s linear",
    transform: "translateY(-100%)",
    boxShadow: "none"
});

const stickyBarShellVisible = css({
    ...stickyBarShellBase,
    zIndex: 22,
    pointerEvents: "auto",
    transition: "transform 0.15s ease-out, box-shadow 0.15s ease-out",
    transform: "translateY(0)",
    boxShadow: "var(--shadows-4)"
});

const buttonStyle = css({
    transitionDuration: "unset",
    transitionTimingFunction: "unset",
    overflow: "initial"
});

const containerStyle = css({
    textAlign: "right",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "100%",
    flexBasis: "100%",

    "& > div:first-of-type": {
        width: "100%",
        flexBasis: "100%"
    }
});
